// extracted by mini-css-extract-plugin
export default {"container":"YY-z","heading":"ZY-z","links":"_Y-z","copy":"aZ-z","subCopy":"bZ-z","linksLeft":"cZ-z","linksCenter":"dZ-z","linksRight":"eZ-z","link":"fZ-z","onlyLink":"gZ-z"};